export const applicationConstants = {
	raisonSocialeEngieGreen: 'ENGIE GREEN FRANCE',
	adresseEngieGreen: '67 rue Jules Ferry 92250 La Garenne-Colombes',
	telFaxEngieGreen: '04 99 52 64 70',
	pdpAutorizedAnnexeType: 'application/pdf',
	// Doit suivre l'ordre defini dans l'enum AccesEtat vue plus bas
	etatAcces: ['planifies', 'en-attente-validation', 'en-cours', 'termines', 'refuses', 'en-conflit', 'annules', 'en-erreur', 'en-attente-fermeture'], 
	etatPdp: ['A faire signer', 'Signé', 'Signé partiellement', 'Brouillon', 'Envoyé via DocuSign', 'Attente de relecture', 'Invalidé'], 
	motifRefus: [
		'Défaut d\'habilitation',
		'Météo',
		'Autre',
		'Coactivité', 
		'Défaut Doc. de sécurité', 
		'Défaut de présence au planning',
		'Intervenant inconnu',
		'Nombre intervenants insuffisant'
	],
	maxNombreSuggestionAcces: 15,
	currentPdpVersion: 3,
	versionInWhichValideursCanSignPdps: 3,
	versionInWhichValideursCanSignPas: 3,
	typeValideurs: [
		{'label': 'Valideur', 'code': 'VALIDEUR'},
		{'label': 'Valideur et Intervenant', 'code': 'VALIDEUR_INTERVENANT'},
		{'label': 'Valideur et Représentant', 'code': 'VALIDEUR_REPRESENTANT'},
		{'label': 'Valideur, Représentant et Intervenant', 'code': 'VALIDEUR_REPRESENTANT_INTERVENANT'}
	],
	emailRegexp : new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
	documentApplicable: [{
		label: 'Plan Prevention (Pdp)',
		value: 'PlanPrevention'
	}, {
		label: 'Personne Avertie (PA)',
		value: 'PersonneAvertie'
	}],
	indicateurs: {
		99: {
			nom: 'Incendie',
			icon: 'fa-brands fa-gripfire'
		},
		2: {
			nom: 'Pluie',
			icon: 'fa-solid fa-cloud-showers-heavy'
		},
		1: {
			nom: 'Vent',
			icon: 'fa-solid fa-wind'
		},
		3: {
			nom: 'Orages',
			icon: 'fa-solid fa-cloud-bolt'
		},
		4: {
			nom: 'Crues',
			icon: 'fa-solid fa-house-flood-water'
		},
		5: {
			nom: 'Neige',
			icon: 'fa-solid fa-snowflake'
		},
		6: {
			nom: 'Canicule',
			icon: 'fa-solid fa-sun'
		},
		7: {
			nom: 'Grand froid',
			icon: 'fa-solid fa-temperature-arrow-down'
		},
		98: {
			nom: 'Tiques',
			icon: 'fa-solid fa-bug'
		},
	} as IndicateurConfigMap
}

type ColorMap = {
	[etat: string]: string,
}

export const etatOuvrageColors: ColorMap = {
	// Pour les Wind Turbine
	'OK': '#52b050',
	'OKD - Dégradé': '#ffc000',
	'KOA - En panne': '#ff0000',
	'KOM - Arrêt technique': '#f769dd',
	'KO - Arrêt externe': '#89479a',
	
	// Pour les autres classes
	'NOK': '#ff0000',
	'Mode dégradé': '#ffc000',
};

export enum AccesEtat {
	// Ces valeurs correspondent a celle de AccesEtat cote serveur
	PLANIFIE,
	ENREGISTRE,
	EN_COURS,
	FERME,
	REFUSE,
	EN_CONFLIT,
	ANNULE,
	ERREUR,
	
	// Ceci est une valeur particuliere traitee a part
	// (est-elle toujours utilisee?)
	ATTENTE_FEMETURE,
}

export enum AccesAction {
	AUTORISER,
	AUTORISER_FERMETURE,
	ASSOCIER_ARRETS,
	ASSOCIER_OPERATIONS,
	CLASSER_EN_ERREUR,
	CREER,
	DEMANDE_VALIDATION,
	DUPLIQUER,
	EXPORTER,
	FERMER,
	INDIQUER_RAPPEL,
	MODIFIER,
	NOTIFIER_PARTICIPANTS,
	REFUSER,
	REFUSER_FERMETURE,
	SUPPRIMER,
	OUVRIR_CONTROLE_SECURITE,
}

export enum ExpirationStatus {
	VALID,
	EXPIRES_WITHIN_TWO_MONTHS,
	EXPIRED,
}

export enum ButtonActions {
	CANCEL,
	SAVE,
	PREVIOUS,
	NEXT,
	SAVE_DRAFT,
	RETURN_TO_LIST,
	EXPORT,
}

export type IndicateurConfig = {
	nom: string,
	icon: string,
};

export type IndicateurConfigMap = {
	[code: number]: IndicateurConfig | undefined,
};

export const couleurIndicateurColors: ColorMap = {
	'NA': '#b0b0b0',
	'VERT': '#52b050',
	'JAUNE': '#ffe000',
	'ORANGE': '#ff9900',
	'ROUGE': '#ff0000',
	'NOIR': '#000000',
};